import config from '../../config/customer.api'
import { Request } from '../shared/base.requests'

const customPageModule = {
  namespaced: true,
  state: {
    page:
    {
      id: 0,
      title: '',
      body: ''
    }
  },
  mutations: {
    setCustomPage (state, data) {
      state.page = data
    }
  },
  actions: {
    loadCustomPage: function (context, data) {
      return new Promise((resolve, reject) => {
        Request.get(config.getCustomPage, {
          id: data
        }).then(response => {
          context.commit('setCustomPage', response.model)
          resolve()
        })
        .catch(error => {
          console.error('load custom page', error)
          reject()
        })
      })
    }
  }
}
export default customPageModule



// WEBPACK FOOTER //
// ./scripts/src/store/custom.page.module.js